<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vHDBIy/tc-custom/9781401687649.jpg?1726454433191" alt="This image is the cover for the book Carolina Gold"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Carolina Gold
      </h1>
      <p class="bookDescription body article font2">
        <p><i>The war is over, but at Fairhaven Plantation, Charlotte's struggle has just begun.</i></p><p>Following her father’s death, Charlotte Fraser returns to Fairhaven, her family’s rice plantation in the South Carolina Lowcountry. With no one else to rely upon, smart, independent Charlotte is determined to resume cultivating the superior strain of rice called Carolina Gold.  But the war has left the plantation in ruins, her father’s former bondsmen are free, and workers and equipment are in short supply.</p><p>To make ends meet, Charlotte reluctantly agrees to tutor the two young daughters of her widowed neighbor and heir to Willowood Plantation, Nicholas Betancourt.  Just as her friendship with Nick deepens, he embarks upon a quest to prove his claim to Willowood and sends Charlotte on a dangerous journey that uncovers a long-held family secret, and threatens everything she holds dear.</p><p>Inspired by the life of a 19th-century woman rice farmer, <i>Carolina Gold</i> pays tribute to the hauntingly beautiful Lowcountry and weaves together  mystery, romance, and historical detail, bringing to life the story of one young woman’s struggle to restore her ruined world.</p><p>A native of west Tennessee, <b>Dorothy Love</b> makes her home in the Texas hill country with her husband and their two golden retrievers. An accomplished author, Dorothy made her debut in Christian fiction with the Hickory Ridge novels.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dorothy Love
      </h2>
      
      <p class="authorDescription body article"><P>A native of west Tennessee,&#160;Dorothy Love&#160;makes her home in the Texas hill country with her husband and their golden retriever. An&#160;award-winning author of numerous young adult novels, Dorothy made her adult debut with the Hickory Ridge novels. Facebook: dorothylovebooks Twitter: @WriterDorothy</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4cc43542